import clsx from 'clsx';

import { ProductListItem } from '~/features/products/components/ProductCardList/ProductListItem';
import { IVariationDetails } from '~/lib/data-contract';
import { Button } from '~/shared/components/Button/Button';
import { useTranslation } from '~/shared/utils/translation/hooks/useTranslation';

import { PopularCategoriesLinks } from './PopularCategoriesLinks';
import styles from './searchDialogContent.module.css';

type SearchProductsAreaProps = {
	products: IVariationDetails[];
	totalResults: number;
	onSubmit: () => void;
};

export const SearchProductsArea = ({ products, totalResults, onSubmit }: SearchProductsAreaProps) => {
	const { translate } = useTranslation();
	const hasResults = products.length > 0;

	return (
		<>
			{!hasResults && <PopularCategoriesLinks />}
			<div
				className={clsx(styles.productsArea, hasResults && styles.visible)}
				aria-live="polite"
			>
				<ol
					className={styles.productList}
					aria-labelledby="search-results"
				>
					{products.map((product) => (
						<ProductListItem product={product} />
					))}
				</ol>

				<div className={clsx(styles.productsAreaFooter, !!totalResults && styles.visible)}>
					<Button onClick={onSubmit}>{translate('search.see-all-products', { count: totalResults })}</Button>
				</div>
			</div>
		</>
	);
};
